export function CreditTopUpUnavailableNotice(): JSX.Element {
  return (
    <aside className="notice notice--info" role="status" style={{ marginBottom: '16px' }}>
      <div>
        <h3 className="notice__title">Top-ups unavailable</h3>
        <p className="notice__message">
          Credit purchases are unavailable until live payment integration is enabled.
        </p>
      </div>
    </aside>
  );
}
